import React from "react";
import PropTypes from "prop-types";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import alertTransitions from "./alertTransitions.module.scss";
import classes from "./styles.module.scss";
import Alert from "./Alert";

const AnimatedWarningAlert = ({ text, className = "" }) => (
  <TransitionGroup>
    {text && (
      <CSSTransition timeout={300} classNames={alertTransitions}>
        <div className={[classes.errorWrapper, className].join(" ")} key={text}>
          <Alert type="WARNING">{text}</Alert>
        </div>
      </CSSTransition>
    )}
  </TransitionGroup>
);

AnimatedWarningAlert.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};

export default AnimatedWarningAlert;
